import { BrowserModule } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA  } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { AgGridModule } from 'ag-grid-angular';
import { OwlDateTimeModule, OwlNativeDateTimeModule, OWL_DATE_TIME_FORMATS } from 'ng-pick-datetime';
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { NgxPaginationModule } from 'ngx-pagination'; // <-- import the module
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive'; // this includes the core NgIdleModule but includes keepalive providers for easy wireup
import { ClipboardModule } from 'ngx-clipboard';
import {CommonModule, DatePipe} from '@angular/common'


import { NotificationService } from './service/notification.service';
import { CommonService } from './service/common-service';
import { ClientUserMappingService } from './service/client-user-mapping.service';

import { AppRoutingModule } from './app-routing.module';
import { CommonModulecomponentModule } from './common-module-component.module';

import { AppComponent } from './app.component';
import { MenuComponent } from './common-components/menu/menu.component';
import { NotificationComponent } from './common-components/notification/notification.component';
import { SelectBoxComponent } from './ag-grid/select-box/select-box.component';
import { DeallocateConcluderComponent } from './deallocate-concluder/deallocate-concluder.component';
import { InventoryUploadComponent } from './inventory-upload/inventory-upload.component';
import { PdfViewerComponent } from './common-components/pdf-viewer/pdf-viewer.component';
import { AccountListModalComponent } from './child-components/agent-correspondance/account-list-modal/account-list-modal.component';
import { CorrespondanceInsuranceMasterModalComponent } from './child-components/agent-correspondance/correspondance-insurance-master-modal/correspondance-insurance-master-modal.component';
import { KyireportComponent } from './landing-page/KYI/kyireport/kyireport.component';
import { FlashdashboardReportComponent } from './landing-page/flashdashboard-report/flashdashboard-report.component';
import { PaymentReportComponent } from './landing-page/payment-report/payment-report.component';

export const MY_CUSTOM_FORMATS = {
  datePickerInput: 'MM/DD/YYYY'
};

@NgModule({
  declarations: [
    AppComponent,
    MenuComponent,
    NotificationComponent,
    // PdfViewerComponent,
    AccountListModalComponent,
    CorrespondanceInsuranceMasterModalComponent,
    KyireportComponent,
    FlashdashboardReportComponent,
    PaymentReportComponent,
    DeallocateConcluderComponent,
    InventoryUploadComponent,
    SelectBoxComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    NgxPaginationModule,
    FormsModule,
    ReactiveFormsModule,
    HttpModule,
    OwlDateTimeModule,
    BrowserAnimationsModule,
    OwlNativeDateTimeModule,
    ClipboardModule,
    // NgbModule,
    NgIdleKeepaliveModule.forRoot(),
    AgGridModule.withComponents([]),
    AppRoutingModule,
    NgMultiSelectDropDownModule.forRoot(),
    CommonModule,
    CommonModulecomponentModule ],
  providers: [
    NotificationService,
    CommonService,
    ClientUserMappingService,
    DatePipe,
    { provide: OWL_DATE_TIME_FORMATS, useValue: MY_CUSTOM_FORMATS }
  ],
  bootstrap: [AppComponent],
  entryComponents: [SelectBoxComponent],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA ]
})
export class AppModule { }
